import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import API from '../api';
import SearchSelect from '../components/SearchSelect';

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    username: '', email: '', first_name: '', last_name: '',
    password: '', password2: '', role: 'etudiant', universite: '',
    faculte: '', promotion: '',
  });
  const [universites, setUniversites] = useState([]);
  const [facultes, setFacultes] = useState([]);
  const [promotions, setPromotions] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    API.get('universites/').then((r) => setUniversites(r.data.results || r.data)).catch(() => {});
    API.get('facultes/').then((r) => setFacultes(r.data.results || r.data)).catch(() => {});
    API.get('promotions/').then((r) => setPromotions(r.data.results || r.data)).catch(() => {});
  }, []);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const payload = { ...form };
      if (!payload.universite) delete payload.universite;
      if (!payload.faculte) delete payload.faculte;
      if (!payload.promotion) delete payload.promotion;
      await register(payload);
      navigate('/dashboard');
    } catch (err) {
      const data = err.response?.data;
      if (data) {
        const messages = Object.values(data).flat().join(' ');
        setError(messages);
      } else {
        setError("Erreur lors de l'inscription.");
      }
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <img src="/icon-.png" alt="Classroom BNN" className="logo-icon" />
          <h1>Inscription</h1>
          <p>Créez votre compte sur Classroom BNN</p>
        </div>
        {error && <div className="error-msg"><i className="bi bi-exclamation-circle" /> {error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="row-2">
            <div className="form-group">
              <label>Prénom</label>
              <input className="form-control" name="first_name" placeholder="Prénom" value={form.first_name} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>Nom</label>
              <input className="form-control" name="last_name" placeholder="Nom" value={form.last_name} onChange={handleChange} required />
            </div>
          </div>
          <div className="form-group">
            <label>Nom d'utilisateur</label>
            <input className="form-control" name="username" placeholder="Identifiant unique" value={form.username} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label>Email</label>
            <input className="form-control" name="email" type="email" placeholder="votre@email.com" value={form.email} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label>Rôle</label>
            <select className="form-control" name="role" value={form.role} onChange={handleChange}>
              <option value="etudiant">Étudiant</option>
              <option value="enseignant">Enseignant</option>
            </select>
          </div>
          <div className="form-group">
            <label>Université / Établissement</label>
            <SearchSelect
              name="universite"
              value={form.universite}
              onChange={handleChange}
              options={universites.map((u) => ({ value: u.id, label: `${u.sigle ? u.sigle + ' – ' : ''}${u.nom}` }))}
              placeholder="-- Sélectionner --"
            />
          </div>
          <div className="row-2">
            <div className="form-group">
              <label>Faculté</label>
              <SearchSelect
                name="faculte"
                value={form.faculte}
                onChange={handleChange}
                options={facultes.map((f) => ({ value: f.id, label: f.nom }))}
                placeholder="-- Faculté --"
              />
            </div>
            {form.role === 'etudiant' && (
              <div className="form-group">
                <label>Promotion</label>
                <SearchSelect
                  name="promotion"
                  value={form.promotion}
                  onChange={handleChange}
                  options={promotions.map((p) => ({ value: p.id, label: p.nom }))}
                  placeholder="-- Promotion --"
                />
              </div>
            )}
          </div>
          <div className="form-group">
            <label>Mot de passe</label>
            <input className="form-control" name="password" type="password" placeholder="Minimum 8 caractères" value={form.password} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label>Confirmer le mot de passe</label>
            <input className="form-control" name="password2" type="password" placeholder="Confirmez votre mot de passe" value={form.password2} onChange={handleChange} required />
          </div>
          <button type="submit" className="btn btn-primary">
            <i className="bi bi-person-plus" /> S'inscrire
          </button>
        </form>
        <div className="auth-footer">
          Déjà inscrit ? <Link to="/login">Se connecter</Link>
        </div>
      </div>
    </div>
  );
}
